module.exports = __webpack_public_path__ + "img/logo2.7d71f7ec.jpg";